import { actions } from '../../utils/constants';

export const fetchAppData = () => ({
    type: actions.ASYNC_FETCH_APP_DATA,
});

export const saveChanges = () => ({
    type: actions.ASYNC_SAVE_CHANGES,
});

export const convertCode = (code) => ({
    type: actions.LOGIN_FROM_CODE,
    payload: { code },
});



// WEBPACK FOOTER //
// ./src/components/app/app.actions.js